export default __webpack_public_path__ + "static/media/1921.0f4faa05.png";